export default "__VITE_ASSET__C588icP7__"